/**
 * Build booking QR payload matching mobile app Bookings.jsx
 */
export function buildBookingQrPayload({ booking, customerId, appConfigName }) {
  return {
    booking_id: booking?.id ?? booking?.booking_id ?? "",
    customer_id: customerId ?? booking?.customer_id ?? "",
    store_id: booking?.store?.id ?? booking?.store_id ?? booking?.storeId ?? "",
    booking_datetime: booking?.booking_datetime ?? "",
    flash_offer_name: null,
    app_config_name: appConfigName ?? "",
  };
}

/**
 * Returns the exact string to pass as QRCode `value`
 */
export function getBookingQrValue({ booking, customerId, appConfigName }) {
  return JSON.stringify(
    buildBookingQrPayload({ booking, customerId, appConfigName })
  );
}
